import React, { FC } from 'react';
import { Grid, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import { useContent } from 'hooks';
import { getProviderDisplay, getTitle } from 'features/content/helpers';

import PostImage from './PostImage';

const useStyles = makeStyles(theme => ({
  title: theme.mixins.clamp(2),
  provider: theme.mixins.clamp(1),
}));

const PartnerSharePreview: FC = () => {
  const classes = useStyles();
  const content = useContent();

  return (
    <Grid container spacing={2} alignItems="center">
      <Grid item>
        <Grid item>
          <PostImage />
        </Grid>
      </Grid>
      <Grid item xs>
        <Typography variant="h6" className={classes.title}>
          {getTitle(content)}
        </Typography>
        <Typography color="textSecondary" className={classes.provider}>
          {getProviderDisplay(content)}
        </Typography>
      </Grid>
    </Grid>
  );
};

export default PartnerSharePreview;
